/**
 * Parking permission keys (catalog `parking.*`, docs/contracts/parking.md §6). The UI hides what a key does not allow; the
 * API checks the same keys and the supervisor of an override per action (P3).
 */
export const parkingPermissions = {
  moduleView: "parking.parking.view",
  entryView: "parking.entry.view",
  entryCreate: "parking.entry.create",
  entryDelete: "parking.entry.delete",
  entryPrint: "parking.entry.print",
  exitView: "parking.exit.view",
  exitCreate: "parking.exit.create",
  exitPrint: "parking.exit.print",
  tariffView: "parking.tariff.view",
  tariffCreate: "parking.tariff.create",
  tariffUpdate: "parking.tariff.update",
  tariffDelete: "parking.tariff.delete",
  shiftView: "parking.shift.view",
  shiftOpen: "parking.shift.create",
  shiftClose: "parking.shift.post",
  shiftPrint: "parking.shift.print",
  shiftCashAudit: "parking.shift.cash_audit",
  campaignView: "parking.campaign.view",
  campaignCreate: "parking.campaign.create",
  campaignUpdate: "parking.campaign.update",
  campaignDelete: "parking.campaign.delete",
  gateCreate: "parking.gate.create",
  gateUpdate: "parking.gate.update",
  gateDelete: "parking.gate.delete",
  override: "parking.ticket.override",
  reportView: "parking.report.view",
  setupView: "parking.setup.view",
} as const;

/** Plan module of the parking screens (P6). */
export const parkingModule = "parking";

/** Settings page group of the parking settings. */
export const parkingSettingsGroup = "parking";
